import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Icon } from '../../../../components/Icon';
import { TrackingUtils, ABUtils } from '../../../../utils';
import { updateSegment } from '../../../../redux/currentSearch/actions';
import { withPageContext } from '../../../../utils/PageContext';
import { isInspirationalSearch } from '../../../../redux/currentSearch/selectors';
import { TabTypeProp, TabTypePropDefault, TripTypeProp } from '../../../../models';
import { useSegmentContext } from '../SegmentManager/Context';

export const SwapButton = ({
    buttonClass,
    getRotateStyle,
    isInspirationalSearch,
    updateSegment,
    trackEvent,
    tripType,
    activeProduct,
}) => {
    const { segment } = useSegmentContext();
    const [rotate, setRotate] = useState(false);
    const { id, origin, destination } = segment;
    const { isCssVariation, isCssVariationMobile, isCssVariationDesktop } = ABUtils.getABs();
    const hotelDestination = destination && !destination.iata;
    const disabled = !origin && (isInspirationalSearch || hotelDestination);

    const getSwapDestination = () => isInspirationalSearch || hotelDestination ? null : destination;

    const onSwapLocations = () => {
        const swapDestination = getSwapDestination();
        const areSelectorsEmpty = !origin && !swapDestination;

        if (!areSelectorsEmpty) {
            updateSegment({
                origin: swapDestination,
                destination: origin,
            }, id);

            const label = TrackingUtils.LABEL.swapLocations({
                origin,
                destination: swapDestination,
                tripType,
            });
            const action = TrackingUtils.ACTION[activeProduct.toUpperCase()];
            trackEvent({ action, label });
        }
    };

    const onClickButton = () => {
        if (!disabled) {
            setRotate(!rotate);
            onSwapLocations();
        }
    };

    const buttonClassNames = classNames({
        'odf-bg-base prisma-btn prisma-btn-default prisma-btn-icon-only prisma-btn-circle': isCssVariation,
        'prisma-btn-sm': isCssVariation && isCssVariationMobile,
        'prisma-btn-xs': isCssVariation && isCssVariationDesktop,
        'odf-btn odf-btn-secondary odf-btn-circle': !isCssVariation,
        [buttonClass]: !isCssVariation,
        'disabled': !isCssVariation && disabled,
        'prisma-btn-disabled': isCssVariation && disabled,
    });
    const classNameIcon= classNames({
        'odf-icon-xl': isCssVariationMobile,
    });

    return (
        <div
            data-testid={'swap-button'}
            className={buttonClassNames}
            onClick={onClickButton}
        >
            <Icon
                className={classNameIcon}
                glyph='swap'
                style={{
                    transform: getRotateStyle(rotate),
                    transition: 'transform 600ms ease-in-out',
                }}
            />
        </div>
    );
};

SwapButton.propTypes = {
    buttonClass: PropTypes.string.isRequired,
    getRotateStyle: PropTypes.func.isRequired,
    isInspirationalSearch: PropTypes.bool.isRequired,
    trackEvent: PropTypes.func.isRequired,
    updateSegment: PropTypes.func.isRequired,
    activeProduct: TabTypeProp,
    tripType: TripTypeProp.isRequired,
};

SwapButton.defaultProps = {
    activeProduct: TabTypePropDefault,
};

const mapStateToProps = ({ currentSearch, activeProduct }) => ({
    activeProduct: activeProduct.activeProduct,
    isInspirationalSearch: isInspirationalSearch({ currentSearch }),
    tripType: currentSearch.tripType,
});

export const ConnectedSwapButton = connect(mapStateToProps, {
    updateSegment,
})(withPageContext(SwapButton));
